import * as React from 'react';
import { Radio } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const RadioGroup = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <Radio.Group {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default RadioGroup;
